import { render, staticRenderFns } from "./DeckDetails.vue?vue&type=template&id=98202ea6&scoped=true"
import script from "./DeckDetails.vue?vue&type=script&lang=ts"
export * from "./DeckDetails.vue?vue&type=script&lang=ts"
import style0 from "./DeckDetails.vue?vue&type=style&index=0&id=98202ea6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98202ea6",
  null
  
)

export default component.exports